module.exports = __webpack_public_path__ + "img/26_178.4a91fa71.png";